import { extendTheme, ThemeOverride } from '@chakra-ui/react';

import { FONTS, FONT_SIZES, FONT_WEIGHTS } from './Typography';
import COLORS from './colors';
import COMPONENTS from './components';
import SEMANTIC_TOKENS from './semanticTokens';

const designSystemCustomTheme = {
  colors: COLORS,
  components: COMPONENTS,
  fonts: FONTS,
  fontSizes: FONT_SIZES,
  fontWeights: FONT_WEIGHTS,
  semanticTokens: SEMANTIC_TOKENS
};

const theme: ThemeOverride<typeof designSystemCustomTheme> = extendTheme(designSystemCustomTheme);

export default theme;
